<template>
    <el-container class="mainJjglxxBody">
        <el-col class="box">
            <el-card class="box-card" shadow="never">
                <div slot="header" class="clearfix">
                    <div class="headOne">{{JjjgxxList.JGMC}}</div>
                    <div class="headSecond">{{JjjgxxList.GSDZ}}</div>
                </div>
                <el-col :span="18">
                    <el-row>
                <span class="xxContent1">
                    姓名：
                </span>
                        <span class="xxContent2">
                    {{JjjgxxList.XM}}
                </span>
                    </el-row>
                    <el-row>
                <span class="xxContent1">
                    从业编号：
                </span>
                        <span class="xxContent2">
                    {{JjjgxxList.CYBH}}
                </span>
                    </el-row>
                    <el-row>
                <span class="xxContent1">
                    资格证编号：
                </span>
                        <span class="xxContent2">
                    {{JjjgxxList.ZGZBH}}
                </span>
                    </el-row>
                    <el-row>
                <span class="xxContent1">
                    联系方式：
                </span>
                        <span class="xxContent2">
                    {{JjjgxxList.LXFS}}
                </span>
                    </el-row>
                    <el-row>
                <span class="xxContent1">
                    所属公司：
                </span>
                        <span class="xxContent2">
                    {{JjjgxxList.SSGS}}
                </span>
                    </el-row>
                    <el-row>
                <span class="xxContent1">
                    公司备案号：
                </span>
                        <span class="xxContent2">
                    {{JjjgxxList.GSBAH}}
                </span>
                    </el-row>
                </el-col>
                <el-col :span="5">
                    <el-row class="cyryDiv">
                        <el-image class="imgCyrytp"
                                  :src="imgUrl"
                        ></el-image>
                    </el-row>
                </el-col>
            </el-card>
            <el-row class="buttonRow">
                <el-button type="primary" @click="onSubmit">我要评价</el-button>
                <el-button type="primary" @click="resetHt">我要投诉</el-button>
            </el-row>
        </el-col>
    </el-container>
</template>

<script>
    import axios from "axios";
    import config from "@/config";
    const base_url = config.baseUrl + 'clf/';
    export default {
        name: "jjjggs_cx",
        data() {
            return {
                JjjgxxList:{
                    JGMC:'汉中鸿润置业有限公司',
                    GSDZ:'汉中市汉台区汉中颐高互联网双创园',
                    BAZH:'某某',
                },
                imgUrl: require("../../img2/jjgl/grtx.png"),
            }
        },
        created() {
            this.grxh = this.$route.query.id;
            axios.get(base_url + "clfxx_jjrxx" + "?grxh=" + this.grxh).then(response => {
                if (!response.data.imgUrl) return;
                this.imgUrl = require("../../img2/jjgl/grtx.png"),
                this.JjjgxxList = response.data;
            }).catch(error => console.log(error, "error"));
        },
        methods: {
            onSubmit(){
                this.warnMessage("功能正完善中...");
            },
            resetHt(){
                this.warnMessage("功能正完善中...");
            },
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
        },
    }
</script>

<style scoped>
    @import "../../assets/css/jjgl/jjglxx_main.css";
</style>